import { render, staticRenderFns } from "./ButtonLaunch.vue?vue&type=template&id=38459354&scoped=true"
import script from "./ButtonLaunch.vue?vue&type=script&lang=js"
export * from "./ButtonLaunch.vue?vue&type=script&lang=js"
import style0 from "./ButtonLaunch.vue?vue&type=style&index=0&id=38459354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38459354",
  null
  
)

export default component.exports